import { autoinject, bindable, bindingMode, customElement } from 'aurelia-framework';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { BaseCustomElement } from 'Common/BaseCustomElement';

@autoinject
@customElement('edit7')
export class Edit7CustomElement extends BaseCustomElement {
}